import {Component, Inject, Input, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AttachedFile, BlobTypes, DocumentBlobTypesUtilities} from '../../models/attached-file.model';
import {Utilities} from '../../utilities/utilities.model';
import {UploadFileService} from '../../service/upload-file.service';
import {Observable} from 'rxjs/Observable';
import {LoaderService} from '@shared/service/loader.service';
import {zip} from 'rxjs';
import {MAT_DIALOG_DATA} from '@angular/material';
import {ClaimsFileType} from '../../../claims/claims-commons/models/file.model';
import {
    GeneralMessageDialogComponent,
    GeneralMessageModel
} from '@shared/components/general-message-dialog/general-message-dialog.component';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import { SharedMessagesCode } from 'app/shared/models/error-response.model';
import { MessageComponentType, MessageType } from '@shared/service/message-manager/message.model';
import { MessageManagerService } from '@shared/service/message-manager/message-manager.service';
import { Module } from '@shared/service/module.service';

@Component({
    selector: 'app-add-attached',
    templateUrl: './add-attached-dialog.component.html',
    styleUrls: ['./add-attached-dialog.component.scss']
})
export class AddAttachedDialogComponent implements OnInit {
    static DRIVER_PERSONAL_DOCUMENTS_CONTEXT = 'DRIVER_PERSONAL_DOCUMENTS_CONTEXT';
    static DOSSIER_ATTACHMENTS_CONTEXT = 'DOSSIER_ATTACHMENTS_CONTEXT';
    static DELEGATE_PERSONAL_DOCUMENTS_CONTEXT = 'DELEGATE_PERSONAL_DOCUMENTS_CONTEXT';
    static WORKING_ATTACHMENTS_CONTEXT = 'WORKING_ATTACHMENTS_CONTEXT';
    static DELIVERY_CERTIFICATE_CONTEXT = 'delivery_certificate';
    static CONTRACT_CLOSING_CERTIFICATE_CONTEXT = 'closing_certificate';
    static BOOKING_ATTACHMENTS_CONTEXT = 'BOOKING_ATTACHMENTS_CONTEXT';

    blobTypeDeliveryCertificateTemporary = BlobTypes.ATTESTATO_DI_CONSEGNA_PROVVISORIO;
    blobTypeAttached = BlobTypes.ALLEGATO;
    blobTypeSurveyAttached = BlobTypes.SURVEY_ATTACHED;

    driver_personal_documents_context = AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT;
    delegate_personal_documents_context = AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT;
    dossier_attachments_context = AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT;
    deliveryCertificateContext = AddAttachedDialogComponent.DELIVERY_CERTIFICATE_CONTEXT;
    closingCertificateContext = AddAttachedDialogComponent.CONTRACT_CLOSING_CERTIFICATE_CONTEXT;

    allowed_extensions = Utilities.allowedExtensions;

    commoditiesID: number[];
    resource_type: string;
    resource_id: any;
    blob_type: string;
    context: string;
    limit = 10;
    form: FormGroup;
    attachedFiles: Array<AttachedFile>;
    preLoadAttachments: AttachedFile[];

    tyre_attachment_type: string; //tyre | ddt
    tyre_transfer_uuid: string;
    tyre_transfer_tyre_uuid: string;

    deletedPreLoadAttachments: string[];

    maxLengthDescription = 45;

    delivery_documents_options = DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS;
    dossier_attachments_options = DocumentBlobTypesUtilities.DOOSIER_ATTACHMENT_OPTIONS;
    deliveryDocumentsOptionsSelected = new Set<string>();
    deliveryDocumentsOptionsNotSelectable = new Set<string>();
    tempDeliveryDocumentsOptionsNotSelectable = [];
    driver_personal_documents_blob_types = DocumentBlobTypesUtilities.DRIVER_PERSONAL_DOCUMENT_BLOB_TYPES;
    delegate_personal_documents_blob_types = DocumentBlobTypesUtilities.DELEGATE_PERSONAL_DOCUMENT_BLOB_TYPES;
    multiple: boolean = false; //Permette di caricare tramite l'explorer più file contemporaneamente di default è false

    // claims
    isClaimAttachment;
    claims_documents_options = [ClaimsFileType.COMPLAINT, ClaimsFileType.PHOTO, ClaimsFileType.OTHER, ClaimsFileType.CAI, ClaimsFileType.ACCIDENTAL_DECLARATION];
    dossier_attachments_blob_types = DocumentBlobTypesUtilities.DOOSIER_ATTACHMENT_BLOB_TYPES;
    translateContext = TranslateContext;

    constructor(public fb: FormBuilder,
                public dialogRef: MatDialogRef<AddAttachedDialogComponent>,
                public uploadFileService: UploadFileService,
                public loaderService: LoaderService,
                private messageManagerService: MessageManagerService,
                public dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        if (
            !Utilities.isEmpty(this.data) && 
            !Utilities.isEmpty(this.data.multiple)
        ) {
            this.multiple = this.data.multiple;
        }
        if(
            !Utilities.isEmpty(this.data) && 
            !Utilities.isEmpty(this.data.limit)
        ){
            this.limit = this.data.limit
        }
        this.attachedFiles = [];
        this.form = fb.group({
            files: this.fb.array([])
        });
        this.isClaimAttachment = data ? data.isClaimAttachment === true : false;
    }

    ngOnInit() {
        setTimeout(() => {
            this.form.markAsPristine({ onlySelf: false });
            this.form.markAsUntouched({ onlySelf: false });
        }, 100);
        if (!Utilities.isVoid(this.preLoadAttachments)) {
            this.deletedPreLoadAttachments = [];
            const control = <FormArray>this.form.controls['files'];
            for (let i = 0; i < this.preLoadAttachments.length; i++) {
                const attachedFile = this.preLoadAttachments[i];
                if (this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT
                    || this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT) {
                    attachedFile.description = DocumentBlobTypesUtilities.getDescriptionToDocumentFileByBlobType(attachedFile.blob_type);
                    this.addDeliveryDocumentsOptionsSelected(attachedFile.description);
                }
                const group = this.initFile(attachedFile.description);
                if (this.context === AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT) {
                    group.disable();
                }
                control.push(group);
                this.attachedFiles.push(attachedFile);
            }
        }
    }

    initFile(mDescription?: string) {
        let validator = [];
        if (this.blob_type !== BlobTypes.ATTESTATO_DI_CONSEGNA_PROVVISORIO
            && this.blob_type !== BlobTypes.VERBALE_DI_RICONSEGNA) {
            validator = [Validators.required, Validators.maxLength(this.maxLengthDescription)]
        }
        if (Utilities.isVoid(mDescription)) {
            mDescription = '';
        }
        return this.fb.group({
            description: [mDescription, validator],
        });
    }

    onFilesChange(files: File[]) {

        if (!Utilities.isVoid(files) && this.attachedFiles.length < this.limit) {

            // Validazione sul nome del file
            for (let f of files) {

                if (!(new RegExp(Utilities.patternFileNameWithNoSpecialChars, 'i')).test(f.name)) {

					this.messageManagerService.pushInnerMessage({ 
                        code: SharedMessagesCode.FILE_UPLOAD_NAME_NOT_VALID, 
                        componentType: MessageComponentType.FLASH_MESSAGE, 
                        type: MessageType.TYPE_ERROR 
                    }, Module.SHARED);
                    this.close(false);
                    return null;
                }
            }

            files.forEach((file) => {
                AttachedFile.createFileContent(file).subscribe((file_content: string) => {
                    if (!Utilities.isVoid(file_content)) {
                        const attachedFile = new AttachedFile();
                        if (this.blob_type === this.blobTypeDeliveryCertificateTemporary) {
                            attachedFile.description = 'AttestatoConsegna_' + this.resource_id
                        }
                        if (this.blob_type === BlobTypes.VERBALE_DI_RICONSEGNA) {
                            attachedFile.description = 'VerbaleDiRiconsegna_' + this.resource_id
                        }
                        if (this.tyre_attachment_type == 'ddt-source' || this.tyre_attachment_type == 'ddt-destination') {
                            attachedFile.description = this.tyre_attachment_type + "-" + this.tyre_transfer_uuid;
                        } else if (this.tyre_attachment_type == 'tyre') {
                            attachedFile.description = this.tyre_attachment_type + "-" + this.tyre_transfer_tyre_uuid;
                        }
                        attachedFile.file_name = file.name;
                        attachedFile.file_content = Utilities.escapeBase64(file_content);
                        attachedFile.resource_type = this.resource_type;
                        attachedFile.resource_id = this.resource_id;
                        attachedFile.blob_type = this.blob_type;
                        attachedFile.file_size = file.size;
                        attachedFile.mime_type = file.type;

                        const control = <FormArray>this.form.controls['files'];
                        control.push(this.initFile(attachedFile.description));
                        this.attachedFiles.push(attachedFile);
                        if ((this.resource_type === UploadFileService.ORDER_RESOURCE_TYPE || this.resource_type === UploadFileService.CONTRACT_CLOSING_RESOURCE_TYPE)
                            && this.context !== AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT
                            && this.context !== AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT) {
                            attachedFile.isInElaboration = true;
                            this.uploadFile(attachedFile).subscribe();
                        }
                        if (this.resource_type === UploadFileService.TYRE_DDT_RESOURCE_TYPE) {
                            attachedFile.isInElaboration = true;
                            if (this.tyre_attachment_type == 'ddt-source' || this.tyre_attachment_type == 'ddt-destination') {
                                this.uploadFileService.uploadDDT(this.tyre_transfer_uuid, attachedFile).subscribe(resp => {
                                    attachedFile.isInElaboration = false;
                                }, error => {
                                    attachedFile.isInElaboration = false;
                                });
                            } else if (this.tyre_attachment_type == 'tyre') {
                                this.uploadFileService.uploadTyreImage(this.tyre_transfer_uuid, this.tyre_transfer_tyre_uuid, attachedFile).subscribe(resp => {
                                    attachedFile.isInElaboration = false;
                                }, error => {
                                    attachedFile.isInElaboration = false;
                                })
                            }
                        }
                    } else {
                        //TODO snack bar error =>
                        // const config = new MatSnackBarConfig();
                        // config.duration = 900;
                        // config.extraClasses = ['snack-bar-success'];
                        // // config.viewContainerRef = this.appContainer.viewContainerRef;
                        //
                    }
                });
            });
        }
    }

    uploadFile(attachedFile: AttachedFile): Observable<boolean> {
        return new Observable<boolean>(observer => {
            this.uploadFileService.uploadFile(attachedFile).subscribe(response => {

                if (!Utilities.isVoid(response) && response.status === 201) {
                    attachedFile.file_content = null;
                    attachedFile.isInElaboration = false;
                    const json = response.json();
                    if (!Utilities.isVoid(json)) {
                        attachedFile.uuid = json.uuid;
                        attachedFile.blob_name = json.blob_name;
                    }
                    observer.next(true);
                } else {
                    observer.next(false);
                }
            }, error => {
                error.next(false);
            });
        });
    }

    remove(index: number) {
        if (this.resource_type === UploadFileService.ORDER_RESOURCE_TYPE ||
            this.resource_type === UploadFileService.CONTRACT_CLOSING_RESOURCE_TYPE ||
            this.resource_type === UploadFileService.AUTHORITY_RESOURCE_TYPE) {
            if (this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT ||
                this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT ||
                this.context === AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT ||
                this.context === AddAttachedDialogComponent.WORKING_ATTACHMENTS_CONTEXT ||
                this.resource_type === UploadFileService.CHANGE_USER_RESOURCE_TYPE) {
                if (!Utilities.isVoid(this.attachedFiles[index].description)) {
                    this.removeDeliveryDocumentsOptionsSelected(this.attachedFiles[index].description);
                }
                if (!Utilities.isVoid(this.preLoadAttachments)
                    && this.preLoadAttachments.filter(file => file.uuid === this.attachedFiles[index].uuid).length === 1) {
                    this.deletedPreLoadAttachments.push(this.attachedFiles[index].uuid);
                }
                this.removeFileFromForm(<FormArray>this.form.controls['files'], index);
                if (this.context === AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT) {
                    const redeliveryIndex = this.attachedFiles.indexOf(this.attachedFiles.find(a => a.description === DocumentBlobTypesUtilities.DOSSIER_ATTACHMENT_OPTION_REDELIVERY_DOCUMENT));
                    if (redeliveryIndex > -1) {
                        if (!this.isPreLoadAttachment(redeliveryIndex)) {
                            this.updateOptionsSelected(redeliveryIndex, { value: null });
                            this.form.controls['files']['controls'][redeliveryIndex].reset();
                        }
                    }
                }
            } else {
                this.deleteFile(index);
            }
        } else {
            this.removeFileFromForm(<FormArray>this.form.controls['files'], index);
        }
    }

    removeFileFromForm(control: FormArray, i: number) {
        control.removeAt(i);
        this.attachedFiles.splice(i, 1);
    }

    deleteFile(i: number) {
        const control = <FormArray>this.form.controls['files'];
        const deleteFile = this.attachedFiles[i];
        deleteFile.isInElaboration = true;

        this.uploadFileService.deleteFile(deleteFile.uuid).subscribe((response) => {
            if (response.status === 202) {
                this.removeFileFromForm(<FormArray>this.form.controls['files'], i);
            } else {
                deleteFile.isInElaboration = false;
                //TODO error message
            }
        });
    }

    close(isSubmit: boolean) {
        if (isSubmit) {
            if (this.form.valid) {
                this.setDescriptionToFiles();
                if (this.resource_type === UploadFileService.ORDER_RESOURCE_TYPE ||
                    this.resource_type === UploadFileService.CONTRACT_CLOSING_RESOURCE_TYPE) {
                    if (this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT ||
                        this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT) {
                        const requests = [];
                        this.attachedFiles.forEach((file) => {
                            this.setBlobTypeToDocumentFile(file);
                            if (!Utilities.isVoid(this.preLoadAttachments) && this.preLoadAttachments.filter(value => value.uuid === file.uuid).length === 1) {
                                requests.push(this.updateFile(file));
                            } else {
                                requests.push(this.uploadFile(file));
                            }
                        });

                        this.closeAfterUploadOrUpdate(requests);

                    } else if (this.context === this.closingCertificateContext
                        || this.context === this.deliveryCertificateContext) {
                        this.dialogRef.close({
                            success: true,
                            attachments: this.attachedFiles,
                            deletedPreLoadAttachments: this.deletedPreLoadAttachments
                        });
                    } else {
                        const requests = [];
                        this.attachedFiles.forEach((item) => {
                            requests.push(this.updateFile(item));
                        });
                        this.closeAfterUploadOrUpdate(requests);
                    }
                } else if (this.context === AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT && this.resource_type === UploadFileService.AUTHORITY_RESOURCE_TYPE) {
                    this.attachedFiles.forEach(f => this.setBlobTypeToDocumentFile(f));
                    if (this.attachedFiles.length && !this.attachedFiles.some(a => a.blob_type === BlobTypes.ACCEPTANCE_REPORT)) {
                        this.openMessageDialog({
                            ...new GeneralMessageModel(),
                            type: GeneralMessageModel.MESSAGE_TYPE_3,
                            title: GeneralMessageModel.TITLE_WARNING,
                            txts: [GeneralMessageModel.TXT_AUTHORITY_ADD_ACCEPTANCE_REPORT],
                            showCloseButton: true
                        }, false);
                        return;
                    }
                    this.dialogRef.close({
                        success: true,
                        attachments: this.attachedFiles,
                        deletedPreLoadAttachments: this.deletedPreLoadAttachments
                    });
                } else if (this.resource_type === UploadFileService.CHANGE_USER_RESOURCE_TYPE) {
                    this.attachedFiles.forEach((file) => {
                        this.setBlobTypeToDocumentFile(file);
                    });
                    this.dialogRef.close({
                        success: true,
                        attachments: this.attachedFiles,
                        deletedPreLoadAttachments: this.deletedPreLoadAttachments
                    });
                } else if (this.resource_type === UploadFileService.CHANGE_USER_RESOURCE_TYPE) {
                    this.attachedFiles.forEach((file) => {
                        this.setBlobTypeToDocumentFile(file);
                    });
                } else {
                    this.dialogRef.close(this.attachedFiles);
                }
            } else {
                Utilities.markFormGroupTouchedAndDirty(this.form);
            }

        } else {
            const dialogResult: {fileRemoved?: boolean} = {};
            if (this.context !== AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT) {
                dialogResult.fileRemoved = this.attachedFiles.length > 0 && (Utilities.isVoid(this.preLoadAttachments) || this.attachedFiles.length > this.preLoadAttachments.length);
                if (this.resource_type === UploadFileService.ORDER_RESOURCE_TYPE
                    && this.context !== AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT
                    && this.context !== AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT) {
                    this.attachedFiles.forEach((item, index) => { this.deleteFile(index) });
                }
            }
            this.dialogRef.close(dialogResult);
        }
    }

    closeAfterUploadOrUpdate(requests: any[]) {
        if (!Utilities.isVoid(requests) && requests.length > 0) {
            zip(...requests).subscribe(
                resps => {
                    let allFilesUploaded = true;
                    for (let i = 0; i < resps.length; i++) {
                        if (Utilities.isVoid(resps[i]) || !resps[i]) {
                            allFilesUploaded = false;
                        }
                    }
                    this.dialogRef.close({
                        success: allFilesUploaded,
                        attachments: this.attachedFiles,
                        deletedPreLoadAttachments: this.deletedPreLoadAttachments
                    });
                });
        } else {

            this.dialogRef.close({ success: true, attachments: [], deletedPreLoadAttachments: this.deletedPreLoadAttachments });
        }
    }

    setDescriptionToFiles() {
        this.attachedFiles.forEach((item, index) => {
            if (this.blob_type !== BlobTypes.ATTESTATO_DI_CONSEGNA_PROVVISORIO) {
                item.description = this.form.get('files').get([index]).get('description').value;
            }
        });
    }

    isOptionSelectable(option: any): boolean {
        return this.tempDeliveryDocumentsOptionsNotSelectable.includes(option);
    }

    openedChangeOptions(index: number) {
        const description = this.attachedFiles[index].description;
        this.tempDeliveryDocumentsOptionsNotSelectable.splice(0);
        this.tempDeliveryDocumentsOptionsNotSelectable.push(...Array.from(this.deliveryDocumentsOptionsSelected));
        this.tempDeliveryDocumentsOptionsNotSelectable.push(...Array.from(this.deliveryDocumentsOptionsNotSelectable));
        if (!Utilities.isVoid(description)) {
            this.removeTempDeliveryDocumentsOptionNotSelectable(description);
            if (this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT || this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT) {
                if (description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA) {
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE);
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO);
                } else if ((description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE
                    && !this.tempDeliveryDocumentsOptionsNotSelectable.includes(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO))
                    || (description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO
                        && !this.tempDeliveryDocumentsOptionsNotSelectable.includes(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE))) {
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA);
                } else if (description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF) {
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE);
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO);
                } else if ((description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE
                    && !this.tempDeliveryDocumentsOptionsNotSelectable.includes(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO))
                    || (description === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO
                        && !this.tempDeliveryDocumentsOptionsNotSelectable.includes(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE))) {
                    this.removeTempDeliveryDocumentsOptionNotSelectable(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE);
                }
            }
        }
        if (this.context === AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT) {
            if (!this.attachedFiles || this.attachedFiles.length < 2 || !this.attachedFiles.find(a => a.blob_type === BlobTypes.ACCEPTANCE_REPORT)) {
                this.tempDeliveryDocumentsOptionsNotSelectable.push(DocumentBlobTypesUtilities.DOSSIER_ATTACHMENT_OPTION_REDELIVERY_DOCUMENT);
            } else {
                this.tempDeliveryDocumentsOptionsNotSelectable.push(DocumentBlobTypesUtilities.DOSSIER_ATTACHMENT_OPTION_ACCEPTANCE_REPORT);
            }
        }
    }

    updateOptionsSelected(index: number, event: any) {
        if (!Utilities.isVoid(this.attachedFiles[index].description)) {
            this.removeDeliveryDocumentsOptionsSelected(this.attachedFiles[index].description);
        }
        const value = !Utilities.isVoid(event) && !Utilities.isVoid(event.value) ? event.value : null;
        this.addDeliveryDocumentsOptionsSelected(value);
        this.attachedFiles[index].description = value;
    }

    private addDeliveryDocumentsOptionsSelected(value: any): void {
        if (!Utilities.isVoid(value)) {
            this.deliveryDocumentsOptionsSelected.add(value);
            if (this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT || this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT) {
                if (value === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA) {
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE);
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO);
                } else if (value === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE
                    && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA)) {
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA);
                } else if (value === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF) {
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE);
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO);
                } else if (value === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE
                    && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF)) {
                    this.deliveryDocumentsOptionsNotSelectable.add(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF);
                }
            }
        }
    }

    removeDeliveryDocumentsOptionsSelected(selected: string): void {
        this.deliveryDocumentsOptionsSelected.delete(selected);
        if (this.context === AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT || this.context === AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT) {
            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE);
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO);
            }
            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE
                && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO)) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA);
            }
            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO
                && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE)) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA);
            }

            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE);
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO);
            }
            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE
                && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO)) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF);
            }
            if (selected === DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO
                && !this.deliveryDocumentsOptionsSelected.has(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE)) {
                this.deliveryDocumentsOptionsNotSelectable.delete(DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF);
            }
        }
    }

    removeTempDeliveryDocumentsOptionNotSelectable(option: string) {
        const index = this.tempDeliveryDocumentsOptionsNotSelectable.indexOf(option);
        if (index >= 0) {
            this.tempDeliveryDocumentsOptionsNotSelectable.splice(index, 1);
        }
    }


    updateFile(file: AttachedFile): Observable<boolean> {
        return new Observable<boolean>(observer => {
            this.uploadFileService.updateFile(file).subscribe(
                resp => {
                    if (Utilities.isVoid(resp) || resp.status !== 200) {
                        const index = this.attachedFiles.indexOf(file);
                        this.remove(index);
                        observer.next(false);
                    } else {
                        observer.next(true);
                    }
                }, error => {
                    const index = this.attachedFiles.indexOf(file);
                    this.remove(index);
                    observer.next(false);
                });
        });
    }

    private setBlobTypeToDocumentFile(file: AttachedFile) {
        switch (this.context) {
            case AddAttachedDialogComponent.DRIVER_PERSONAL_DOCUMENTS_CONTEXT:
                file.blob_type = DocumentBlobTypesUtilities.getBlobTypeForDocument(file.description, this.driver_personal_documents_blob_types);
                break;
            case AddAttachedDialogComponent.DELEGATE_PERSONAL_DOCUMENTS_CONTEXT:
                file.blob_type = DocumentBlobTypesUtilities.getBlobTypeForDocument(file.description, this.delegate_personal_documents_blob_types);
                break;
            case AddAttachedDialogComponent.DOSSIER_ATTACHMENTS_CONTEXT:
                file.blob_type = DocumentBlobTypesUtilities.getBlobTypeForDocument(file.description, this.dossier_attachments_blob_types);
                break;
        }
    }

    onKeyPress(event: any) {
        if (Utilities.pressedEnter(event)) {
            event.preventDefault();
            event.stopPropagation();
            this.close(true);
        }
    }

    private isPreLoadAttachment(index: number) {
        return this.preLoadAttachments.some(a => a.uuid === this.attachedFiles[index].uuid);
    }

    private openMessageDialog(generalMessage: GeneralMessageModel, disableClose: boolean): Observable<any> {
        const dialogRef: MatDialogRef<GeneralMessageDialogComponent> = this.dialog.open(GeneralMessageDialogComponent, {
            height: 'auto',
            width: '800px',
            disableClose: disableClose
        }) as MatDialogRef<GeneralMessageDialogComponent>;
        dialogRef.componentInstance.generalMessageDialog = generalMessage;
        return dialogRef.afterClosed();
    }
}